import React, { useState } from "react";
import styles from "./Card.module.css";
import * as d3 from "d3";

const parse_time = d3.timeParse("%m/%d/%Y");

const Card = ({ sample }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.Card}>
      <div className={styles.Summary}>
        <div className={styles.Meta}>
          <p>
            <span>{sample["PRODUCT TYPE"]}</span>
            {sample["PRODUCT TYPE"] === "Flower Lot" ? (
              <span> / {sample.STRAIN}</span>
            ) : null}
          </p>
          <p>{d3.timeFormat("%B %e, %Y")(parse_time(sample.DATE))}</p>
        </div>
        <h3>
          {sample["PRODUCT NAME"] ? sample["PRODUCT NAME"] : sample["STRAIN"]}
        </h3>
        <h4>{sample["LIC NAME"]}</h4>
      </div>
      {expanded ? (
        <div>
          <table>
            <thead>
              <tr>
                <th />
                <th>Value</th>
                <th>Pass/ Fail</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>THC potency</td>
                <td>{sample["THC (Potency)"]}%</td>
                <td className={styles[sample["THC PASS-FAIL"]]}>
                  {sample["THC PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>THCA potency</td>
                <td>{sample["THCA (Potency)"]}%</td>
                <td className={styles[sample["THCA PASS-FAIL"]]}>
                  {sample["THCA PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>CBD potency</td>
                <td>{sample["CBD (Potency)"]}%</td>
                <td className={styles[sample["CBD PASS-FAIL"]]}>
                  {sample["CBD PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>CBDA potency</td>
                <td>{sample["CBDA (Potency)"]}%</td>
                <td className={styles[sample["CBDA PASS-FAIL"]]}>
                  {sample["CBDA PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>Total potency</td>
                <td>{sample["TOTAL (Potency)"]}%</td>
                <td className={styles[sample["TOTAL PASS-FAIL"]]}>
                  {sample["TOTAL PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>Total viable aerobic bacteria</td>
                <td></td>
                <td className={styles[sample["TOTAL AEROBIC PASS-FAIL"]]}>
                  {sample["TOTAL AEROBIC PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>Total yeast and mold</td>
                <td></td>
                <td className={styles[sample["YEAST MOLD PASS-FAIL"]]}>
                  {sample["YEAST MOLD PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>Total coliforms</td>
                <td></td>
                <td className={styles[sample["TOTAL COLIFORM PASS-FAIL"]]}>
                  {sample["TOTAL COLIFORM PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>Bile-tolerant gram-negative bacteria</td>
                <td></td>
                <td className={styles[sample["BILE TOL PASS-FAIL"]]}>
                  {sample["BILE TOL PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>E.coli and salmonella</td>
                <td></td>
                <td className={styles[sample["ECOLI SALM PASS-FAIL"]]}>
                  {sample["ECOLI SALM PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>Residual solvents</td>
                <td>
                  {sample["RESID SOLV"] ? sample["RESID SOLV"] + "ppm" : null}
                </td>
                <td className={styles[sample["RESID SOLV PASS-FAIL"]]}>
                  {sample["RESID SOLV PASS-FAIL"]}
                </td>
              </tr>
              <tr>
                <td>Pesticides</td>
                <td></td>
                <td className={styles[sample["PESTICIDE PASS-FAIL"]]}>
                  {sample["PESTICIDE PASS-FAIL"]
                    ? sample["PESTICIDE PASS-FAIL"]
                    : "N/A"}
                </td>
              </tr>
            </tbody>
          </table>
          <div className={styles.LotSample}>
            <p>Lot #{sample["LOT"]}</p>
            <p>Sample #{sample["SAMPLE"]}</p>
          </div>
        </div>
      ) : null}
      <button onClick={() => setExpanded(!expanded)}>
        {expanded ? "Deembiggen" : "Embiggen"}
      </button>
    </div>
  );
};

export default Card;
